import { Route } from "react-router-dom";
import AdminLayout from "../layout/AdminLayout";
import ProfitAndLoss from "../components/views/Master/Profit And Loss/ProfitAndLoss";
import AccountList from "../components/views/AccountList";
import Bank from "../components/views/Bank";
import BankUpdate from "../components/views/AccountData/Bank/BankUpdate.jsx";
import Currency from "../components/views/Currency";
import Income from "../components/views/Income";
import IncomeUpdate from "../components/views/AccountData/Income/IncomeUpdate.jsx";
import IncomeType from "../components/views/IncomeType";
import Expense from "../components/views/Expense";
import ExpenseUpdate from "../components/views/AccountData/Expense/ExpenseUpdate.jsx";
import ExpenseType from "../components/views/ExpenseType";
import FixAsset from "../components/views/FixAsset";
import BalanceSheet from "../components/views/BalanceSheet";
import TrialBabl from "../components/views/TrailBabl";
import MedicineSale from "../components/views/MedicineSale";
import AccountType from "../components/views/AccountType";
import Heading from "../components/views/Heding";
import SubHeader from "../components/views/SubHeader";
import Category from "../components/views/Master/Category";
import SubCategory from "../components/views/Master/SubCategory";
import Brand from "../components/views/Master/Brand";
import AddAsset from "../components/views/AddAsset";
import MedicineList from "../components/views/Master/MedicineList/MedicineList";
import Unit from "../components/views/Master/MedicineList/Unit";
import ProcedureMedicine from "../components/views/Master/Procedure Medicine/ProcedureMedicine";
import ProUnit from "../components/views/Master/Procedure Medicine/ProUnit";
import StockCount from "../components/views/StockCount";
import StockHistory from "../components/StockHistory.jsx";
import StockUnit from "../components/views/StockUnit";
import StockMedUnit from "../components/views/StockMedUnit";
import Purchase from "../components/views/Purchase";
import PurchaseDetail from "../components/views/PurchaseDetail";
import PurchaseAdd from "../components/views/PurchaseAdd";
import StockProAss from "../components/views/StockProAssUnit";
import TreatmentCreate from "../components/views/Master/Treatment/TreatmentCreate";
import CheckUnit from "../components/views/Master/Treatment/CheckUnit";
import SellEndDialog from "../components/views/SellEndDialog";
import Supplier from "../components/views/Supplier";
import CreditDetail from "../components/views/CreditDetail";
import MedicineUpdate from "../components/views/Master/MedicineList/MedicineUpdate";
import TreatmentSale from "../components/views/TreatmentSale";
import AccListUpdate from "../components/views/AccListUpdate";
import ProUpdate from "../components/views/Master/Procedure Medicine/ProUpdate.jsx";
import TreatUpdate from "../components/views/Master/Treatment/Update.jsx";
import TCheckList from "../components/views/Master/Treatment/UnitCreate.jsx";
import ProcedureAccessory from "../components/views/Master/ProAccess/ProAccess";
import ProAccessUpdate from "../components/views/Master/ProAccess/ProUpdate.jsx";
import ProAccessUnit from "../components/views/Master/ProAccess/ProAccessUnit";
import TransferList from "../components/views/Master/Transfer/TransferList";
import StockList from "../components/views/Master/Log/LogList";
import Update2 from "../components/views/Master/Treatment/UnitUpdate2";
import Doctor from "../components/views/Admin/Doctor/DoctorList.jsx";
import DoctorReg from "../components/views/Admin/Doctor/Register.jsx";
import DoctorUpdate from "../components/views/Admin/Doctor/DoctorUpdate.jsx";
import DoctorCommission from "../components/views/Admin/Doctor/Commission.jsx";
import AllTran from "../components/views/Master/Transaction/AllTransaction.jsx";
import StockRequest from "../components/views/Admin/StockRequest/StockRequestList.jsx";
import StockReqCreate from "../components/views/Admin/StockRequest/StockRequestCreate.jsx";
import SQUpdate from "../components/views/Admin/StockRequest/SQUpdate.jsx";
import StockTran from "../components/views/Admin/StockTransfer/StockTransferList.jsx";
import StockTranCreate from "../components/views/Admin/StockTransfer/StockTranCreate.jsx";
import STUpdate from "../components/views/Admin/StockTransfer/StockTranUpdate";
import ShowPrint from "../components/views/Admin/StockRequest/ShowPrint.jsx";
import STPrint from "../components/views/Admin/StockTransfer/TShowPrint.jsx";
import JournalEntry from "../components/views/AccountData/JournalEntryList.jsx";
import JournalUpdate from "../components/views/AccountData/JournalEntry/JEUpdate.jsx";
import Machine from "../components/views/Master/Machine/Machine.jsx";
import Discount from "../components/views/Admin/Discount/DiscountList.jsx";
import Member from "../components/views/Admin/Member/MemberList.jsx";
import ReOrderList from "../components/views/Admin/Reorder/ReorderList.jsx";
import Package from "../components/views/Admin/PackageList/PackageList.jsx";
import PackageReg from "../components/views/Admin/PackageList/PackageReg.jsx";
import PackageUpdate from "../components/views/Admin/PackageList/PackageUpdate.jsx";
import SaleReturn from "../components/views/Admin/SaleReturn/SaleReturnList.jsx";
import Top10 from "../components/views/Admin/Top10/Top10List.jsx";
import Advance from "../components/views/Admin/Advance/AdvanceList.jsx";
import UserList from "../components/views/Admin/User/UserList.jsx";
import UserDetail from "../components/views/Admin/User/UserDetail.jsx";
import PurchaseAddFromReOder from "../components/views/Admin/PurchaseFormReOrder/AddPurchase";
import BCReport from "../components/views/AccountData/BCReport/bcreport.jsx";
import AccReport from "../components/views/AccountData/AccountReport/AccountReport.jsx";
import General from "../components/views/Master/General Item/General.jsx";
import GeneralItems from "../components/views/Master/General Item/GeneralItems.jsx";
import GeneralUpdate from "../components/views/Master/General Item/GeneralUpdate.jsx";
import PurchaseReceived from "../components/views/Admin/Purchase/PurchaseReceived.jsx";
import PurchaseTransfer from "../components/views/Admin/Purchase/PurchaseTransfer.jsx";
import PurchaseTransferList from "../components/views/Admin/Purchase/PurchaseTranList.jsx";
import MemberUpdate from "../components/views/Admin/Member/MemberUpdate.jsx";
import ApproveDetail from "../components/views/Admin/Purchase/PurApproveDetail.jsx";
import DisUpdate from "../components/views/Admin/Discount/DisUpdate.jsx";
import Customer from "../components/views/Admin/Customer/customerList.jsx";
import NurComission from "../components/views/Admin/Doctor/NurCom.jsx";
import TheComission from "../components/views/Admin/Doctor/TheCommission.jsx";
import KMax from "../components/views/Admin/KMax/kmax.jsx";
import ExpDateList from "../components/views/Admin/ExpiredDateList/expDateList.jsx";
import ExpDateListDetail from "../components/views/Admin/ExpiredDateList/detailItems.jsx";
import TransferReport from "../components/views/AccountData/transferReportList.jsx";
import IssueToHO from "../components/views/Admin/IssueHO/issue_to_ho_create.jsx";
import IssueList from "../components/views/Admin/IssueHO/issue_to_ho_list.jsx";
import IssueDetail from "../components/views/Admin/IssueHO/issue_to_ho_detail.jsx";
import ReceiveFromPOS from "../components/views/Admin/ReceiveFromPOS/receiveList.jsx";
import DentalTreatment from "../components/views/Master/Dental Treatment/dental_treatment_list.jsx";
import DentalCheckUnit from "../components/views/Master/Dental Treatment/dental_checkunit.jsx";
import DentalCheckUnitCreate from "../components/views/Master/Dental Treatment/dental_unit_create.jsx";
import DentalCheckUnitUpdate from "../components/views/Master/Dental Treatment/dental_unit_update.jsx";
import DentalUpdate from "../components/views/Master/Dental Treatment/dental_update.jsx";
import { Voucher } from "../components/views/Admin/Voucher/Voucher.jsx";
import VoucherDetail from "../components/views/Admin/Voucher/VoucherDetail.jsx";
import RefundVoucherDetailPage from "../pages/Voucher/RefundVoucherDetailPage.jsx";
import RefundPage from "../pages/Refund/RefundPage.jsx";
import SettingLayout from "../layout/SettingLayout.jsx";
import SettingPage from "../pages/Settings/SettingPage.jsx";

const AdminRoutes = (
  <Route element={<AdminLayout />}>
    <>
      <Route path="/profit-and-loss" element={<ProfitAndLoss />} />
      <Route path="/stock-list" element={<StockList />} />
      <Route path="/transfer-list" element={<TransferList />} />
      <Route path="/fix_asset" element={<FixAsset />} />
      <Route path="/sellEnd/:id" element={<SellEndDialog />} />
      <Route path="/expense" element={<Expense />} />
      <Route path="/expense-update/:expenseid" element={<ExpenseUpdate />} />
      <Route path="/expense_type" element={<ExpenseType />} />
      <Route path="/income" element={<Income />} />
      <Route path="/income-update/:incomeid" element={<IncomeUpdate />} />
      <Route path="/income_type" element={<IncomeType />} />
      <Route path="/currency" element={<Currency />} />
      <Route path="/bank" element={<Bank />} />
      <Route path="/bank-update/:bankid" element={<BankUpdate />} />
      <Route path="/account_list" element={<AccountList />} />
      <Route path="/balance_sheet" element={<BalanceSheet />} />
      <Route path="/trail_bal" element={<TrialBabl />} />
      <Route path="/medicineSale" element={<MedicineSale />} />
      <Route path="/acc_type" element={<AccountType />} />
      <Route path="/head" element={<Heading />} />
      <Route path="/subHead" element={<SubHeader />} />
      <Route path="/category" element={<Category />} />
      <Route path="/sub_category" element={<SubCategory />} />
      <Route path="/brand" element={<Brand />} />
      <Route path="/add_asset" element={<AddAsset />} />
      <Route path="/medicine_list" element={<MedicineList />} />
      <Route path="/medUp/:id" element={<MedicineUpdate />} />
      <Route path="/unit/:id" element={<Unit />} />
      <Route path="/pro_medicine" element={<ProcedureMedicine />} />
      <Route path="/prounit/:id" element={<ProUnit />} />
      <Route path="/stock" element={<StockCount />} />
      <Route path="/voucher" element={<Voucher />} />
      <Route path="/voucher/:id" element={<VoucherDetail />} />
      <Route path="/stock-history" element={<StockHistory />} />
      <Route path="/stockUnit/:id" element={<StockUnit />} />
      <Route path="/stockMed/:id" element={<StockMedUnit />} />
      <Route path="/stockProAss/:id" element={<StockProAss />} />
      <Route path="/purchase" element={<Purchase />} />
      <Route path="/purchaseDetail/:id" element={<PurchaseDetail />} />
      <Route path="/add_purchase" element={<PurchaseAdd />} />
      <Route path="/treatC" element={<TreatmentCreate />} />
      <Route path="/checkUnit/:id" element={<CheckUnit />} />
      <Route path="/supplier" element={<Supplier />} />
      <Route path="/creditDetail/:id" element={<CreditDetail />} />
      <Route path="/treatSale" element={<TreatmentSale />} />
      <Route path="/accUpdate/:id" element={<AccListUpdate />} />
      <Route path="/proUpdate/:id" element={<ProUpdate />} />
      <Route path="/treatUpdate/:id" element={<TreatUpdate />} />
      <Route path="/TCL/:id" element={<TCheckList />} />
      <Route path="/unitUpdate/:id1/:id2" element={<Update2 />} />
      <Route path="/pro-access" element={<ProcedureAccessory />} />
      <Route path="/proAcessUpdate/:id" element={<ProAccessUpdate />} />
      <Route path="/proAccessUnit/:id" element={<ProAccessUnit />} />
      <Route path="/doctor" element={<Doctor />} />
      <Route path="/doctor-reg" element={<DoctorReg />} />
      <Route path="/dnt-update/:doctorid" element={<DoctorUpdate />} />
      <Route path="/refDoctor/:doctorid" element={<DoctorCommission />} />
      <Route path="/all-tran" element={<AllTran />} />
      <Route path="/stock-req" element={<StockRequest />} />
      <Route path="/stock-req-create" element={<StockReqCreate />} />
      <Route path="/sq-Update/:id" element={<SQUpdate />} />
      <Route path="/show-print/:printid" element={<ShowPrint />} />
      <Route path="/stock-tran" element={<StockTran />} />
      <Route path="/stock-tran-create/:id" element={<StockTranCreate />} />
      <Route path="/st-update/:id" element={<STUpdate />} />
      <Route path="/show-tran-print/:id" element={<STPrint />} />
      <Route path="/journal-list" element={<JournalEntry />} />
      <Route path="/je-update/:jeid" element={<JournalUpdate />} />
      <Route path="/machine" element={<Machine />} />
      <Route path="/discount" element={<Discount />} />
      <Route path="/dis-update/:id" element={<DisUpdate />} />
      <Route path="/member" element={<Member />} />
      <Route path="/mem-update/:id" element={<MemberUpdate />} />
      <Route path="/reorder" element={<ReOrderList />} />
      <Route path="/package" element={<Package />} />
      <Route path="/packageReg" element={<PackageReg />} />
      <Route path="/package-update/:packageid" element={<PackageUpdate />} />
      <Route path="/sale-return" element={<SaleReturn />} />
      <Route path="/top10" element={<Top10 />} />
      <Route path="/advance" element={<Advance />} />
      <Route path="/user" element={<UserList />} />
      <Route path="/user-detail/:id" element={<UserDetail />} />
      <Route path="/add_purchase_reOrder/:data" element={<PurchaseAddFromReOder />} />
      <Route path="/bc-report" element={<BCReport />} />
      <Route path="/acc-report" element={<AccReport />} />
      <Route path="/gen" element={<General />} />
      <Route path="/general-item/:id" element={<GeneralItems />} />
      <Route path="/gen-update/:id" element={<GeneralUpdate />} />
      <Route path="/pur-rec/:id" element={<PurchaseReceived />} />
      <Route path="/pur-tran/:id" element={<PurchaseTransfer />} />
      <Route path="/appr-detail/:id" element={<ApproveDetail />} />
      <Route path="/pur-tranlist" element={<PurchaseTransferList />} />
      <Route path="/customer" element={<Customer />} />
      <Route path="/refthe/:id" element={<TheComission />} />
      <Route path="/refnur/:id" element={<NurComission />} />
      <Route path="/knas" element={<KMax />} />
      <Route path="/expDateList" element={<ExpDateList />} />
      <Route path="/expDetail/:id" element={<ExpDateListDetail />} />
      <Route path="/transferreport-list" element={<TransferReport />} />
      <Route path="/issue-ho" element={<IssueToHO />} />
      <Route path="/issue-list" element={<IssueList />} />
      <Route path="/issue_detail/:id" element={<IssueDetail />} />
      <Route path="/receive-pos" element={<ReceiveFromPOS />} />
      <Route path="/dental-treatment" element={<DentalTreatment />} />
      <Route path="/dental-update/:id" element={<DentalUpdate />} />
      <Route path="/dental-check/:id" element={<DentalCheckUnit />} />
      <Route path="/dental-check-create/:id" element={<DentalCheckUnitCreate />} />
      <Route path="/dental-check-update/:id1/:id2" element={<DentalCheckUnitUpdate />} />
      <Route path="/setting" element={<SettingLayout />}>
        <Route index element={<SettingPage />} />
        <Route path="refund" element={<SettingPage />} />
      </Route>
      <Route path="/refund" element={<RefundPage />} />
      <Route path="/voucher/refund/:id" element={<RefundVoucherDetailPage />} />
    </>
  </Route>
);

export default AdminRoutes;
